import React, {useEffect, useState} from 'react';

import {Navigate} from 'react-big-calendar';

import SchedulePlaner from "../weekPlaner/SchedulePlaner";
import {fetchWeek, postCourse, postCourseTemp} from "../api/api";

export default function WeexDay({date, localizer, ...props}){
  const [days, setDays] = useState(props.events?.days)
  const [editSeries, setEditSeries] = useState(true);

  async function fetch(type= "temp"){
      return fetchWeek(date.toLocaleDateString('de-DE'), date.toLocaleDateString('de-DE'), type);
  }
  useEffect( () => {
    setDays(null)
    if(editSeries)
      fetch().then((week)=>setDays(week.days))
    else
      fetch("single").then((week)=>setDays(week.days))
  },[date, editSeries])

  function sendCourseTemp(data){
    const jsonString = JSON.stringify(data, (key, value) => {
      if(key === 'parallels') //has circularises
        return null
      if(key === 'startDate' || key === 'endDate'){
        //datum mit 00:00 ist wegen timezone +1/2 am tag davor, weil stringify ISO nutzt
        return new Date(value).toLocaleDateString('de-DE');
      }
      else return value
    });

    if(editSeries)
      return postCourseTemp(date.toLocaleDateString('de-DE'), date.toLocaleDateString('de-DE'), jsonString).then((a)=>setDays(a.days))
    else
      return postCourse(date.toLocaleDateString('de-DE'), date.toLocaleDateString('de-DE'), jsonString).then((a)=>setDays(a.days))

  }


  return (<div>
      <SchedulePlaner week0={days} startOfWeek={date} editSeries={editSeries} setEditSeries={setEditSeries} addCourseTmp={sendCourseTemp} fetchWeek={e => fetch(e).then((week)=>setDays(week.days))} date={date}/>
    </div>
  );
}

WeexDay.navigate = (date, action, {localizer}) => {
  switch(action){
    case Navigate.PREVIOUS:
      return localizer.add(date, -1, 'day');

    case Navigate.NEXT:
      return localizer.add(date, 1, 'day');

    default:
      return date;
  }
};

WeexDay.title = (date, {localizer}) => {
  return `${date.toLocaleDateString('de-DE')}`;
};